// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CourseListener } from './course-listener';
import { FileItem } from './file-item';

/**
 * 
 * @export
 * @interface PracticePass
 */
export interface PracticePass {
    /**
     * 
     * @type {string}
     * @memberof PracticePass
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PracticePass
     */
    body: string;
    /**
     * 
     * @type {Array<FileItem>}
     * @memberof PracticePass
     */
    files?: Array<FileItem>;
    /**
     * 
     * @type {string}
     * @memberof PracticePass
     */
    status: PracticePassStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PracticePass
     */
    comment?: string;
    /**
     * 
     * @type {CourseListener}
     * @memberof PracticePass
     */
    listener: CourseListener;
    /**
     * 
     * @type {Date}
     * @memberof PracticePass
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PracticePass
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PracticePass
     */
    passedAt?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum PracticePassStatusEnum {
    Passed = 'passed',
    NotPassed = 'not_passed',
    Waiting = 'waiting',
    SendToRevision = 'send_to_revision'
}



